import { apiService } from "./ApiService";

export const removeFromFavorite = (gameId: string) => {
  return apiService.deleteApi<unknown>({
    path: `v1/me/favorites/${gameId}`,
    body: {
      gameId,
    },
  });
};
